<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { snacks } from '../store/snacks';
  import type { Snack } from '../types';
  import { uiClasses } from '../config';
  import { cn } from '@shared/lib';
  import { theme } from '@shared/ui/theme/model';

  export let snack: Snack;

  const { type, message, id } = snack;
</script>

<li
  class="{cn(
    'snack flex items-center justify-between gap-5 rounded-[8px] p-5 backdrop-blur-xl before:absolute before:left-0 before:top-0 before:-z-10 before:h-full before:w-full before:rounded before:bg-opacity-[0.6]',
    type,
    {
      [`${type}__dark`]: $theme.mode === 'dark',
    },
  )}"
>
  <div class="flex items-center gap-5 overflow-hidden">
    <span class="{uiClasses[type]} dark:text-default-50">
      <Icon classes="shrink-0" name="{type}" width="{20}" height="{20}" />
    </span>

    <div class="message text-default-900 dark:text-default-50">
      <!-- eslint-disable-next-line -->
      {@html message}
    </div>
  </div>

  <button class="text-default-900 dark:text-default-50 hover:scale-105" on:click="{() => snacks.remove(id)}">
    <Icon classes="shrink-0" name="close" width="{20}" height="{20}" />
  </button>
</li>

<style lang="scss">
  @media screen and (min-width: 768px) {
    .message {
      width: clamp(100px, 500px, 40vw);
    }
  }

  .snack {
    animation: ease-out 10s fadeOut;
    animation-iteration-count: 1;
  }

  @keyframes fadeOut {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }

    5%,
    80% {
      transform: translateY(0);
      opacity: 100;
    }

    95%,
    100% {
      opacity: 0;
      transform: translateY(-100%);
    }
  }

  .info {
    background: linear-gradient(0deg, rgba(245, 245, 245, 0.5) 0%, rgba(245, 245, 245, 0.5) 100%),
      rgba(147, 197, 253, 0.6);

    &__dark {
      background: linear-gradient(0deg, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.25) 100%),
        rgba(60, 60, 60, 0.6);
    }
  }

  .success {
    background: linear-gradient(0deg, rgba(245, 245, 245, 0.5) 0%, rgba(245, 245, 245, 0.5) 100%),
      rgba(110, 231, 183, 0.6);

    &__dark {
      background: linear-gradient(0deg, rgba(16, 185, 129, 0.25) 0%, rgba(16, 185, 129, 0.25) 100%),
        rgba(60, 60, 60, 0.6);
    }
  }

  .error {
    background: linear-gradient(0deg, rgba(245, 245, 245, 0.5) 0%, rgba(245, 245, 245, 0.5) 100%),
      rgba(252, 165, 165, 0.6);

    &__dark {
      background: linear-gradient(0deg, rgba(239, 68, 68, 0.25) 0%, rgba(239, 68, 68, 0.25) 100%), rgba(60, 60, 60, 0.6);
    }
  }

  .warn {
    background: linear-gradient(0deg, rgba(245, 245, 245, 0.5) 0%, rgba(245, 245, 245, 0.5) 100%),
      rgba(252, 211, 77, 0.7);

    &__dark {
      background: linear-gradient(0deg, rgba(251, 191, 36, 0.25) 0%, rgba(251, 191, 36, 0.25) 100%),
        rgba(60, 60, 60, 0.6);
    }
  }
</style>
